"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toResultHistoryInvestors = exports.TypeDocInvestor = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var TypeDocInvestor;
(function (TypeDocInvestor) {
    TypeDocInvestor["R\u00E9sultat annuel"] = "Annuel";
    TypeDocInvestor["R\u00E9sultat semestriel"] = "Semestriel";
})(TypeDocInvestor = exports.TypeDocInvestor || (exports.TypeDocInvestor = {}));
var getDocuments = function (data, logger) {
    var _a;
    var allDocs = {
        docListAnnuel: {
            title: data.primary.title_annuel,
            documents: []
        },
        docListSemestriel: {
            title: data.primary.title_semestriel,
            documents: []
        }
    };
    (_a = data.items) === null || _a === void 0 ? void 0 : _a.forEach(function (doc) {
        var type = TypeDocInvestor[doc.doc_type];
        var document = {
            title: fields_1.toText(doc.doc_title),
            link: fields_1.toMediaLink(doc.doc_link, logger)
        };
        if (!document.title || !document.link || !type) {
            return undefined;
        }
        allDocs["docList" + type].documents.push(document);
    });
    return utils_1.compact(allDocs);
};
var toResultHistoryInvestors = function (data, logger) {
    var _a, _b, _c;
    return utils_1.compact(__assign(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.ResultHistoryInvestors)), { year: logger.required(fields_1.toText((_a = data.primary) === null || _a === void 0 ? void 0 : _a.year)), event: utils_1.compact({
            date: fields_1.toText((_b = data.primary) === null || _b === void 0 ? void 0 : _b.event_date),
            description: fields_1.toText((_c = data.primary) === null || _c === void 0 ? void 0 : _c.event_description)
        }) }), getDocuments(data, logger)));
};
exports.toResultHistoryInvestors = toResultHistoryInvestors;
//# sourceMappingURL=result-history-investors.js.map